import React from 'react';
import BaseProtocol from '../Application/BaseProtocol';
import { OT_PROTOCOL_ITEMS } from './otProtocolConstants';

const OtProtocol = ({ targetUserId, onClose }) => {
    return (
        <BaseProtocol
            role="OT"
            title="OT JOB DESCRIPTION"
            items={OT_PROTOCOL_ITEMS}
            apiEndpoint="/job-descriptions"
            fetchEndpoint="/job-descriptions"
            defaultValues={{
                userId: targetUserId
            }}
            onClose={onClose}
        />
    );
};

export default OtProtocol;
